import React from "react"
import { OrderLineInfoWrapper, OrderLineRow, ProductNameWrapper } from "../Shared.styled"
import Money from "../../Money"
import DineroFactory from "dinero.js"
import { ShippingFee } from "lib/types/generated/graphql-types"
import { ReactComponent as ShippingIcon } from "images/icons/truck-ramp-box.svg"

type Props = {
  shippingFee: ShippingFee | undefined
}

const OperationShippingFee = ({ shippingFee }: Props) => {
  return (
    <OrderLineRow>
      <OrderLineInfoWrapper>
        <ShippingIcon />
        <ProductNameWrapper>
          <b>{shippingFee?.displayName}</b>
          <Money
            amount={shippingFee?.salePriceAmount ?? 0}
            currencyUnit={shippingFee?.currencyCode as DineroFactory.Currency}
          />
        </ProductNameWrapper>
      </OrderLineInfoWrapper>
    </OrderLineRow>
  )
}

export default OperationShippingFee
